import { render, staticRenderFns } from "./loadDealsDialog.vue?vue&type=template&id=34f21a52&scoped=true&lang=pug"
import script from "./loadDealsDialog.vue?vue&type=script&lang=js"
export * from "./loadDealsDialog.vue?vue&type=script&lang=js"
import style0 from "./loadDealsDialog.vue?vue&type=style&index=0&id=34f21a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f21a52",
  null
  
)

export default component.exports